const local = {
  bookdemo: {
    Link: "https://agentaviator-bookdemo.stage.neuralcompany.team/aiaviator",
  },
};

const dev = {
  bookdemo: {
    Link: "https://agentaviator-bookdemo.stage.neuralcompany.team/aiaviator",
  },
};

const prod = {
  bookdemo: {
    Link: "https://demo.akira.ai/aiaviator/",
  },
};

const config =
  process.env.REACT_APP_STAGE === "production"
    ? prod
    : process.env.REACT_APP_STAGE === "development"
    ? dev
    : // : process.env.REACT_APP_STAGE === "uat"
      // ? uat
      local;
// eslint-disable-next-line
export default {
  ...config,
};
